module.exports = __webpack_public_path__ + "img/ic-linkedin.fba0d761.svg";